import Overlay from '../js-bridge/overlay';
import {
	FetchAllNodeInstances,
	FetchNodeInstances,
	SetPrimaryAttribute,
	SetAttributes,
	SetIdentificationAttribute,
	GetPrimaryAttribute,
	GetAttribute,
	GetRefAttribute,
	GetIdentificationAttributes,
	EraseInstance

}
from '../js-bridge/overlayutil';
var stgname = "DD@uullyysseess";
var LocalDemo=null;
//new runtime
var ns="http://ath-dt-smichail:55556/";
//Previous runtime
//var ns="http://ath-dt-smichail:44449/";

function cmp(a,b){
	
 return a.statusvalue.localeCompare(b.statusvalue);
}

function Overlays(srv){
 return new Overlay(ns+srv);
}
export default function OverlayService(){
 return new Overlay(ns+"overlayService.svc");
}


//function getUrlPar(k){
// var p={};
// location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){p[k]=v})
// return k?p[k]:p;
//}
function initStorage(){
  let s={
    "context":"DDEvent"
   };
  localStorage.setItem(stgname,JSON.stringify(s));
}
function pushStorage(key,value){
	let s=JSON.parse(localStorage.getItem(stgname));
                s[key]= value;
 	localStorage.setItem(stgname,JSON.stringify(s));
}
function getStorageKey(key){
	let s=JSON.parse(localStorage.getItem(stgname));
	return  s[key];
}
function getStorageKeyAndReset(key){
	let s=JSON.parse(localStorage.getItem(stgname));
	var res=  s[key];
	s[key]=null;
	localStorage.setItem(stgname,JSON.stringify(s));
               return res;
}
function getStorage(){
	return JSON.parse(localStorage.getItem(stgname));
}
function clearStorageKey(key){
	let s=JSON.parse(localStorage.getItem(stgname));
                s[key]=null;
	localStorage.setItem(stgname,JSON.stringify(s));
}
function clearStorage(){
	initStorage();
}

//=======================================================
function clearDDInitiationRecords(overlayService, modelId,id){
 var unames=[
	'abd7e576-7406-42cf-a6b8-0a7102f4f9e7',
	'INITIATEDRYDOCKINGEVENT',
	'VALIDATEDDESTIMATIONDATES',
	    'SELECTDDPROJECTNUMBER',
		'SELECTDDVESSEL',
		'SELECTDDESTIMATEDSTARTDATE', 
		'SELECTDDESTIMATEDCOMPLETIONDATE',
		 'SELECTDDTYPE',
		'SELECTDDINTERVALTYPE'
                  ];
		
		unames.forEach(
			function(item){
			   var ctx=[id];
			   //var rp=SEARCHTYPE_PARTIAL_MATCH;
			   var rp=1;
			   if (item=='abd7e576-7406-42cf-a6b8-0a7102f4f9e7'){
			    ctx=[id];
				 
				}
				
				var nodes=FetchNodeInstances(overlayService, modelId, item,ctx ,rp );
				nodes.forEach(
					function(sitem){
						EraseInstance(overlayService, modelId,item,sitem.contextIds);
					}
				);
			}
		);
		

}





function DeleteDDEvent(EventId){
		try{
			//initialize the overlay service js object
			var overlayService = Overlays("overlayService.svc");
			//Get currently loaded Model ID
			var modelId;
			var retVal = overlayService.GetHostedModelId();
			if (retVal.success == true) {
				modelId = retVal.data;
			}
		var stg=getStorage();
		var ctx=[EventId];
		//var nodes=FetchNodeInstances(overlayService, modelId, "SELECTJOBFORJOBLIST", ctx, SEARCHTYPE_PARTIAL_MATCH);
		var nodes=FetchNodeInstances(overlayService, modelId, "SELECTJOBFORJOBLIST", ctx, 1);
		if (nodes.length>0){
		  return {"status":1,"error":"Event with job list cannot be deleted. Please clear job list and repeat."};
		}
			clearDDInitiationRecords(overlayService,modelId,ctx[0]);
			return {"status":0,"error":null,"deletedId":EventId};
		}
		catch(e){
	 		return {"status":1,"error":e.message};
		}
}
//=========================================================================









// WEBPACK FOOTER //
// ./src/components/Utils/js-bridge/GenUtil.js